<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
  id: {
    type: [String, Number],
    required: true,
  },
  icon: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
});

const context = inject('buttonGroupContext');

const isActive = computed(() => context.activeId.value === props.id);

const buttonClasses = computed(() => {
  const baseClasses = [
    'transition-colors rounded-none',
    context.sizeClasses[context.size.value],
  ];

  if (isActive.value) {
    baseClasses.push('bg-violet-25 dark:bg-slate-700 text-n-primary font-bold');
  } else {
    baseClasses.push(
      'bg-white dark:bg-slate-900 text-n-secondary font-bold hover:text-n-primary hover:bg-gray-50 dark:hover:bg-slate-800'
    );
  }

  return baseClasses.join(' ');
});

const handleClick = () => {
  context.onClick(props.id);
};
</script>

<template>
  <button
    class="first:border-l-0 border-l border-solid border-n-weak"
    :class="[buttonClasses]"
    @click="handleClick"
  >
    <span v-if="icon" :class="icon" />
    <span v-if="label || $slots.default">
      <slot>{{ label }}</slot>
    </span>
  </button>
</template>
